import React from 'react';
import PropTypes from 'prop-types';
import { FaBars } from 'react-icons/fa';

const Burger = ({ open, setOpen }) => {
  return (
    <div open={open} onClick={() => setOpen(!open)}>
      <FaBars
        style={{
          fontSize: 'var(--space-xl)',
          cursor: 'pointer',
          color: 'var(--yellow4)',
        }}
      />
    </div>
  );
};
Burger.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};

export default Burger;
